import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import moment from "moment/moment";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { getExchangeRateHistoryData } from "../../../Services/measurementService";

const HistoricalExchangeRateDrawer = (props) => {
  const [form] = Form.useForm();
  const [exchangeRateHistoryData, setExchangeRateHistoryData] = useState();

  useEffect(() => {
    getExchangeRateHistoryData().then((response) => {
        let currency = [];
      let data = response;
      for (let index = 0; index < data.data.length; index++) {
        data.data[index]["time_A"] = moment(data.data[index].timestamp_A).format("HH:mm");
        data.data[index]["time_B"] = moment(data.data[index].timestamp_B).format("HH:mm");
        data.data[index]["date_A"] = moment(data.data[index].timestamp_A).format("DD/MM/YYYY");
        data.data[index]["date_B"] = moment(data.data[index].timestamp_A).format("DD/MM/YYYY");
        currency.push(data.data[index]);
      }
      setExchangeRateHistoryData(currency);
    });
  }, []);

  return exchangeRateHistoryData && exchangeRateHistoryData.length ?  (
    <RightDrawerSidebar
      title={"Historical Exchange Rate"}
      subtitle=""
      visible={props.visible}
      onClose={() => {
        props.onClose();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm inputPadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                form={form}
              >
                <div
                  className="drawerField2"
                  style={{ paddingTop: "0px", paddingBottom: "25px" }}
                >
                  <div className="">
                    <Button
                      className="textTypeBtn textBtnIcon"
                      style={{ margin: "0px" }}
                      onClick={() => props.onBack()}
                    >
                      <Iconmoon icon="left-to-thin" size={12} color="#EA655B" />{" "}
                      &nbsp;&nbsp; Go back to current exchange rates
                    </Button>
                  </div>
                </div>

                <Row className="centerAlign justifyCSBetween">
                  <Col span={6} style={{ paddingRight: "5px" }}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <p>Currency</p>
                    </div>
                  </Col>

                  <Col span={5} style={{ paddingRight: "5px" }}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <p>Exchange Rate</p>
                    </div>
                  </Col>

                  <Col span={13}>
                    <div className="boxFormType" style={{ marginBottom: "0" }}>
                      <p>Validity</p>
                    </div>
                  </Col>
                </Row>
                {exchangeRateHistoryData.map((data, index) => {
                  return (
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={6} style={{ paddingRight: "5px" }}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name={`unit${index}`}
                            rules={[{ required: true }]}
                            initialValue={`${data.currency} to ${data.default_currency}`}
                            className="dBlock"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input className="unit-input" style={{paddingLeft : "7px !important",fontSize:"12px"}} disabled />
                          </Form.Item>
                        </div>
                      </Col>

                      <Col span={5} style={{ paddingRight: "5px" }}>
                        <div
                          className="boxFormType"
                          style={{ marginBottom: "0" }}
                        >
                          <Form.Item
                            name={`rate${index}`}
                            rules={[{ required: true }]}
                            initialValue={
                              data.exchange_rate
                            }
                            className="dBlock"
                            style={{ marginBottom: "5px" }}
                          >
                            <Input disabled />
                          </Form.Item>
                        </div>
                      </Col>

                      <Col span={13}>
                        <div
                          style={{
                            border: "2px solid #dfe1e6",
                            boxSizing: "border-box",
                            borderRadius: "8px",
                            height: "40px",
                            fontSize: "14px",
                            fontFamily: "var(--sf-pro-text)",
                            color: "#323130",
                            boxShadow: "none !important",
                            overflow: "hidden",
                            borderRightWidth: "2px !important",
                            backgroundColor: "#f3f2f1",
                            padding: '4px 11px',
                            paddingLeft:'7px',
                          }}
                        >
                          {" "}
                          <p style={{marginBottom:'0px', color: "#323130",lineHeight:"18px"}}>{data.date_A} - {data.date_B}</p>
                           <p style={{marginBottom:'0px',lineHeight:"15px",fontSize:"10px"}}> <span style={{paddingRight:'50px'}}>{data.time_A}</span> <span>{data.time_B}</span></p>
                        </div>
                      </Col>
                      <p style={{ fontSize: "10px" }}>
                            1 {data.currency} = {data.exchange_rate}{" "}
                            {data.default_currency}
                          </p>
                    </Row>
                  );
                })}
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default HistoricalExchangeRateDrawer;
